<template>
  <div class="DrkWhite pa-4">
      <h2 class="subheading green--text">Revision Schedules</h2>
      <v-card class="mt-4">
      <Revision/>
  </v-card>
  </div>
</template>

<script>
import Revision from '@/components/Utils/Revision.vue'
  export default {
    components: {
      Revision
    },
    data: () => ({
    }),
  }
</script>

<style scoped>
</style>